import React from 'react';
import FooterStyle from './FooterStyle';

const Footer = () => (
    <FooterStyle>
        <footer>
            ©BHKLab 2023
        </footer>
    </FooterStyle>
);

export default Footer;
